export enum activatedLenderBorrowerLinkStatuses {
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
  BLACKLISTED = "BLACKLISTED",
}
